// extracted by mini-css-extract-plugin
module.exports = {"sectionTitle":"sectionTitle--g7dSN"};